interface GlobalLoaderProps {
  isVisible: boolean;
  message?: string;
}

export const GlobalLoader = ({ isVisible, message = "Processing..." }: GlobalLoaderProps) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999]">
      <div className="bg-slate-800/95 backdrop-blur-sm rounded-xl p-6 flex flex-col items-center justify-center space-y-3 min-w-[180px] shadow-2xl border border-slate-700/50">
        <div className="relative w-8 h-8">
          <div className="absolute inset-0 rounded-full border-2 border-solid border-slate-600"></div>
          <div className="absolute inset-0 rounded-full animate-spin border-2 border-solid border-blue-400 border-t-transparent"></div>
        </div>
        <p className="text-white text-sm font-medium text-center">{message}</p>
      </div>
    </div>
  );
};
